
export let API_URL = 'https://aziende.consultala.com/api'

export let API_DIPENDENTI_URL = 'https://dipendenti.consultala.com/'

if (import.meta.env.VITE_APP_ENV === 'development') {
  console.log('development')
  API_URL = 'http://aziende.lvh.me:8001/api'
  API_DIPENDENTI_URL = 'http://dipendenti.lvh.me:8001/'
}

// else if(document.location.href.includes('aziende.lvh.me')) {
//   API_URL = 'http://aziende.lvh.me:8000/api'
// }

else if(document.location.href.includes('aziende.dev.consultala.com')) {
  API_URL = 'https://aziende.dev.consultala.com/api'
  API_DIPENDENTI_URL = 'https://dipendenti.dev.consultala.com/'
}

else if (document.location.href.includes('hr.dev.consultala.com')) {
  API_URL = 'https://aziende.dev.consultala.com/api'
  API_DIPENDENTI_URL = 'https://dipendenti.dev.consultala.com/'
}

else if (document.location.href.includes('aziende.lvh.me')) {
  API_URL = 'http://aziende.lvh.me:8001/api'
  API_DIPENDENTI_URL = 'http://dipendenti.lvh.me:8001/'
}

// get the last ten years from now
export const years = Array.from({ length: 10 }, (v, k) => {
  return {
    value: k + (new Date()).getFullYear() - 9,
    label: k + (new Date()).getFullYear() - 9
  }
}).reverse()

// get a list of months with number and label in italian 
export const months = [
  { value: 1, label: 'Gennaio' },
  { value: 2, label: 'Febbraio' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Aprile' },
  { value: 5, label: 'Maggio' },
  { value: 6, label: 'Giugno' },
  { value: 7, label: 'Luglio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Settembre' },
  { value: 10, label: 'Ottobre' },
  { value: 11, label: 'Novembre' },
  { value: 12, label: 'Dicembre' },
  { value: 13, label: 'Tredicesima' },
  { value: 14, label: 'Quattordicesima' },
  { value: 15, label: 'Quindicesima' },
  { value: 16, label: 'Sedicesima' },
  { value: 17, label: 'Diciassettesima' }
]

const maxNumber = 50;

for (let i = 18; i <= maxNumber; i++) {
  months.push({ value: i, label: i.toString() });
}
